import { useCallback, useEffect, useState } from "react"
import moment from 'moment'

import { Model } from "../../../models/model"
import { NewDateFilters } from "./DateFilters"
import { Link } from "react-router-dom"
import { Tooltip } from "@mui/material"

export const Tasks = ({ handleEditById, filtersCrm, onTasksChanged }) => {

    const [tasks, setTasks] = useState([])
    const [filters, setFilters] = useState({
        estado: '',
        time: 'all',
        fecha_desde: null,
        fecha_hasta: null,
        incluir_completadas: true,
        crm_id_tipo: filtersCrm.id_tipo
    })

    const getTasksCrm = useCallback(async () => {
        const params = (new URLSearchParams(filters)).toString()
        const results = await Model.getAll({ url: `crm/tasks/all/?${params}` })
        setTasks(results)
    }, [filters])

    const handleDoneChange = async (e, id) => {
        const { checked } = e.target

        const newTasks = tasks.map(it => {
            if (it.id === id) {
                return {
                    ...it,
                    done: checked
                }
            }

            return it
        })

        setTasks(newTasks)

        await Model.update({
            url: `crm/task/updateState/${id}`,
            dataForm: {
                id,
                status: checked
            },
            resultData: true
        })
        onTasksChanged?.();

    }

    const handleChangeFilterDate = (newValue, targetName) => {
        setFilters(prev => ({
            ...prev,
            [targetName]: moment(newValue).format('YYYY-MM-DD')
        }))
    }

    const handleChangeFilterCheck = (e) => {
        const { checked } = e.target

        setFilters(prev => ({
            ...prev,
            incluir_completadas: checked
        }))

    }

    useEffect(() => {
        getTasksCrm()
    }, [filters, getTasksCrm])

    useEffect(() => {

        setFilters(prev => ({
            ...prev,
            crm_id_tipo: filtersCrm.id_tipo
        }))

    }, [filtersCrm.id_tipo])

    return (
        <div className="table-responsive bg-white p-2 mt-4 rounded-lg">

            <NewDateFilters
                filters={filters}
                setFilters={setFilters}
                handleChangeDate={handleChangeFilterDate}
            />

            <div>
                <label htmlFor="completadas-hoy" className="ms-3 mt-2 flex">
                    <input
                        id="completadas-hoy"
                        type="checkbox"
                        className="cursor-pointer w-4"
                        onChange={handleChangeFilterCheck}
                        checked={filters.incluir_completadas}
                    />
                    <span className="ms-1 text-[14px]">incluir completadas hoy</span>
                </label>
            </div>

            <table className="table p-table-global mt-3">
                <thead className='p-thead-global'>
                    <tr className="text-center p-tr-titles-global">
                        <td className="text-center text-[#595759] font-bold">Completado</td>
                        <td className="text-start text-[#595759] font-bold">Asunto</td>
                        <td className="text-start text-[#595759] font-bold">Oportunidad</td>
                        <td className="text-start text-[#595759] font-bold">Etapa</td>
                        <td className="text-start text-[#595759] font-bold">Vencimiento</td>
                        <td className="text-[#595759] font-bold text-start">Correo eléctronico</td>
                        <td className="text-[#595759] font-bold">Fono</td>
                    </tr>
                </thead>
                <tbody>
                    {tasks.map(it => (
                        <tr
                            key={it.id}
                            className={`${it.vencida ? 'text-red-500' : (it?.done ? 'text-green-600' : 'text-gray-500')} text-[14px]`}
                        >
                            <td className="text-center">
                                <div className="flex justify-center">
                                    <input
                                        className="w-6 h-4 cursor-pointer"
                                        type="checkbox"
                                        checked={it?.done || false}
                                        onChange={(e) => handleDoneChange(e, it.id)}
                                    />
                                    {(it.done && it.fecha_completado) && <span className="text-[11px]">({it.fecha_completado})</span>}
                                </div>

                            </td>
                            <td className="text-start">
                                <div>
                                    <div className="flex items-center">
                                        <Tooltip title={it?.nombre_clasificacion || 'Sin clasificación'}>
                                            <i className={`${it?.clasificacion_icon_name || 'bi bi-check2-circle'} text-[14px] me-1 text-black`}></i>
                                        </Tooltip>
                                        <p className="ms-2 first-letter:uppercase text-[16px]">{it.nombre}</p>
                                    </div>
                                    {(it.nota_larga !== '' && it.nota_larga !== null) &&
                                        <div className="mt-2 bg-[#f9f3fa] p-2 rounded-lg w-fit ms-4">
                                            <span className="font-extrabold">Nota:</span>
                                            <p className="text-[15px] text-gray-600">{it.nota_larga}</p>
                                        </div>
                                    }
                                </div>
                            </td>
                            <td className="items-start">
                                <div className="capitalize text-[16px]">{it?.contacto || '--'}</div>
                                <Link
                                    className="text-gray-500 hover:underline hover:text-[#8E24AA] text-[13px]"
                                    to=""
                                    onClick={() => handleEditById(it.oportunidad_id, it.etapa_id)}
                                >
                                    {it.oportunidad}
                                </Link>
                            </td>
                            <td>{it.etapa_nombre}</td>
                            <td className="text-start">
                                <span className="text-[13px]">{it.fecha}</span>
                                {it.hora && <span className="me-1 text-[13px]"> {it.hora}</span>}
                            </td>
                            <td className="text-start">{it?.email || '--'}</td>
                            <td className="text-center">{it?.fono || '--'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}
